const TAB_CLASSNAMES_BY_SIZE = {
    s: 'tw-font-link2',
    m: 'tw-font-link4',
    l: 'tw-font-h4'
};
export { TAB_CLASSNAMES_BY_SIZE };
